import {
  Box,
  Button,
  Dialog,
  FormControl,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { RootState, Spinner } from "shared";
import styles from "../../prepare-invoice/styles/prepareInvoice.module.scss";
import { useFormUpdateUsers } from "../hook/useFormUpdateUsers";
import { useSelector } from "react-redux";
import { fieldFormUpdateUsers } from "../helper/fieldFormUpdateUsers";
import { columnsUsersType } from "../types/columsUsers.types";
import { useUserManagement } from "../hook/useUserManagement";

interface FormUpdateUsersProps {
  user?: columnsUsersType;
  userName: string;
}

const FormUpdateUsers = ({ user, userName }: FormUpdateUsersProps) => {
  const {
    formikRef,
    initialValues,
    isLoading,
    handleBlurSelectDepartment,
    handleSubmit,
    onlyNumbers,
    validationSchema,
  } = useFormUpdateUsers(userName, user);
  const { onCloseModal } = useUserManagement();

  const { optionsDropdowns } = useSelector((state: RootState) => state);
  const [dataFields, setDataFields] = useState<any[]>([]);

  useEffect(() => {
    const userFields = fieldFormUpdateUsers(optionsDropdowns);
    setDataFields(userFields);
  }, [optionsDropdowns]);

  return (
    <>
      <div className={styles.container}>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={(values) => handleSubmit(values)}
          validationSchema={validationSchema}
          enableReinitialize={true}
          validateOnBlur={true}
          validateOnChange={true}
        >
          {(formik) => (
            <Form
              className={styles.formPrepareInvoice}
              data-testid="form-invoice"
            >
              <Grid container>
                {dataFields.map((fieldData, i) =>
                  fieldData.type === "select" ? (
                    <Grid item xs={12} md={6} lg={4} key={i}>
                      <FormControl fullWidth className={styles.itemForm}>
                        <label
                          htmlFor={fieldData.id}
                          className={`${fieldData.required ? "text-required" : "label-form-required"}`}
                        >
                          {fieldData.label}{" "}
                        </label>
                        <Field
                          id={fieldData.id}
                          placeholder={fieldData.placeholder}
                          variant="outlined"
                          name={fieldData.name}
                          maxLength={fieldData.maxLength}
                          className={
                            formik.touched[fieldData.name] &&
                            Object.keys(formik.errors).includes(fieldData.name)
                              ? styles.errorCampo
                              : ""
                          }
                          as={fieldData.type}
                          onBlur={(e: any) => {
                            formik.setFieldTouched(fieldData.name);
                            fieldData.id === "itemformDeparment"
                              ? handleBlurSelectDepartment(e)
                              : formik.validateForm();
                          }}
                          data-testid={`select_${fieldData.name}`}
                        >
                          <option value="">--</option>
                          {fieldData.options?.map((option: any) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </Field>
                        <Box display="flex" justifyContent="space-between">
                          <span className={styles.spanError}>
                            {fieldData.required &&
                              Object.keys(formik.errors).includes(
                                fieldData.name,
                              ) &&
                              formik.touched[fieldData.name] &&
                              "Campo requerido"}
                          </span>
                        </Box>
                      </FormControl>
                    </Grid>
                  ) : fieldData.type === "textNumber" ? (
                    <Grid item xs={12} md={6} lg={4} key={i}>
                      <FormControl fullWidth className={styles.itemForm}>
                        <label
                          htmlFor={fieldData.id}
                          className={`${fieldData.required ? "text-required" : "label-form-required"}`}
                        >
                          {fieldData.label}
                        </label>
                        <div
                          className={`${styles.containerItemTel} ${fieldData.required && Object.keys(formik.errors).includes(fieldData.name) && formik.touched[fieldData.name] && styles.errorCampo}`}
                        >
                          <Field
                            id={fieldData.id}
                            placeholder={fieldData.placeholder}
                            type={fieldData.type}
                            variant="outlined"
                            name={fieldData.name}
                            maxLength={fieldData.maxLength}
                            className={""}
                            autoComplete="off"
                            onBlur={() =>
                              formik.setFieldTouched(fieldData.name)
                            }
                            onKeyPress={(event: any) => {
                              isNaN(Number(event.key)) &&
                                event.preventDefault();
                            }}
                            onPaste={onlyNumbers}
                            data-testid={`input_${fieldData.name}`}
                          />
                          <span className={styles.itemIndicator}>+57</span>
                        </div>
                        <Box display="flex" justifyContent="space-between">
                          <span className={styles.spanError}>
                            {fieldData.required &&
                              Object.keys(formik.errors).includes(
                                fieldData.name,
                              ) &&
                              formik.touched[fieldData.name] &&
                              ""}
                            {formik.touched[fieldData.name] &&
                              formik.errors[fieldData.name]}
                          </span>
                          <span
                            className={styles.spanCounter}
                            data-testid={`error_field_${fieldData.name}`}
                          >
                            {formik?.values?.[fieldData.name]?.toString()
                              .length || 0}
                            /{fieldData.maxLength}
                          </span>
                        </Box>
                      </FormControl>
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={6} lg={4} key={i}>
                      <FormControl fullWidth className={styles.itemForm}>
                        <label
                          htmlFor={fieldData.id}
                          className={`${fieldData.required ? "text-required" : "label-form-required"}`}
                        >
                          {fieldData.label}{" "}
                        </label>
                        <Field
                          id={fieldData.id}
                          placeholder={fieldData.placeholder}
                          type={fieldData.type}
                          variant="outlined"
                          name={fieldData.name}
                          maxLength={fieldData.maxLength}
                          className={
                            fieldData.required &&
                            Object.keys(formik.errors).includes(fieldData.name)
                              ? formik.touched[fieldData.name] &&
                                styles.errorCampo
                              : ""
                          }
                        />
                        <Box display="flex" justifyContent="space-between">
                          <span className={styles.spanError}>
                            {fieldData.required &&
                              Object.keys(formik.errors).includes(
                                fieldData.name,
                              ) &&
                              formik.touched[fieldData.name] &&
                              ""}
                            {formik.touched[fieldData.name] &&
                              formik.errors[fieldData.name]}
                          </span>
                          <span
                            className={styles.spanCounter}
                            data-testid={`error_field_${fieldData.name}`}
                          >
                            {formik?.values?.[fieldData.name]?.toString()
                              .length || 0}
                            /{fieldData.maxLength}
                          </span>
                        </Box>
                      </FormControl>
                    </Grid>
                  ),
                )}
                <Grid item xs={12}>
                  <div className={styles.containerButtons}>
                    <Button
                      className={styles.buttonCancel}
                      onClick={() => {
                        onCloseModal();
                        formikRef.current?.resetForm();
                      }}
                      data-testid="button-cancel"
                    >
                      {"Cancelar"}
                    </Button>
                    <Button
                      type="submit"
                      data-testid="button-submit"
                      variant="contained"
                      className={styles.buttonSubmit}
                    >
                      Guardar
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
      {isLoading && <Spinner />}
    </>
  );
};

export default FormUpdateUsers;
